import { styled } from 'styled-components';
import { Media } from '../../../../../theme/Media';
export const TableNoDataWrapper = styled.div `
  width: 100%;

  @media ${Media.xsMax} {
    border-radius: 8px;
    overflow: hidden;
  }
`;
export const TableNoDataInnerWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 555px;
  background: ${({ theme }) => theme.colors.grey00_1};
  padding: 96px 24px 0;
  gap: 24px;

  & > svg {
    max-width: 100%;
  }
`;
